var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgArtBusiness = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 60,
    viewBox: "0 0 72 60",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50.064%",
    x2: "99.965%",
    y2: "50.064%",
    id: "triyrubpwa"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEEEE9",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFE3ED",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "-2429.606%",
    x2: "100%",
    y2: "-2429.606%",
    id: "4cvmldnsdb"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEEEE9",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFE3ED",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-474.525%",
    y1: "50.064%",
    x2: "-471.074%",
    y2: "50.064%",
    id: "kydz6gyc9c"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEEEE9",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFE3ED",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50.064%",
    x2: "100%",
    y2: "50.064%",
    id: "l4uzsmo5ad"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEEEE9",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFE3ED",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F6C760",
    d: "M0 0h24.212v59.946H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#1B7690"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.816 32.468h2.55v3.152h-2.55zM11.456 25.79h2.55v3.08h-2.55zM11.456 32.468h2.55v3.152h-2.55zM4.07 25.79h2.55v3.08H4.07zM4.07 32.468h2.55v3.152H4.07z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M18.816 39.417h2.55v3.08h-2.55zM11.456 39.417h2.55v3.08h-2.55zM11.456 46.235h2.55v3.08h-2.55zM4.07 39.417h2.55v3.08H4.07z"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "#64C0C3",
    d: "M17.802 25.959h23.027v33.986H17.802z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#triyrubpwa)",
    d: "M0 0h4.889v1.327H0z",
    transform: "translate(19.562 28.622)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#4cvmldnsdb)",
    d: "M10.603 0h5.004v1.327h-5.004z",
    transform: "translate(19.562 28.622)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#kydz6gyc9c)",
    d: "M0 3.843h4.889V5.17H0z",
    transform: "translate(19.562 28.622)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#l4uzsmo5ad)",
    d: "M10.603 3.843h5.004V5.17h-5.004z",
    transform: "translate(19.562 28.622)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#kydz6gyc9c)",
    d: "M0 7.673h4.889V9H0z",
    transform: "translate(19.562 28.622)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#l4uzsmo5ad)",
    d: "M10.603 7.673h5.004V9h-5.004z",
    transform: "translate(19.562 28.622)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#kydz6gyc9c)",
    d: "M0 11.516h4.889v1.327H0z",
    transform: "translate(19.562 28.622)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#l4uzsmo5ad)",
    d: "M10.603 11.516h5.004v1.327h-5.004z",
    transform: "translate(19.562 28.622)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#kydz6gyc9c)",
    d: "M0 0h4.889v1.327H0z",
    transform: "translate(19.562 43.93)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#l4uzsmo5ad)",
    d: "M10.603 0h5.004v1.327h-5.004z",
    transform: "translate(19.562 43.93)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#kydz6gyc9c)",
    d: "M0 3.843h4.889V5.17H0z",
    transform: "translate(19.562 43.93)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#l4uzsmo5ad)",
    d: "M10.603 3.843h5.004V5.17h-5.004z",
    transform: "translate(19.562 43.93)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#kydz6gyc9c)",
    d: "M0 7.673h4.889V9H0z",
    transform: "translate(19.562 43.93)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#l4uzsmo5ad)",
    d: "M10.603 7.673h5.004V9h-5.004z",
    transform: "translate(19.562 43.93)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#kydz6gyc9c)",
    d: "M0 11.516h4.889v1.327H0z",
    transform: "translate(19.562 43.93)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#l4uzsmo5ad)",
    d: "M10.603 11.516h5.004v1.327h-5.004z",
    transform: "translate(19.562 43.93)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1B7690",
    d: "M36.767 3.481h20.899v56.465H36.767z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#F6C760"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.413 43.316H55.02v1.213H39.413zM39.413 46.17H55.02v1.214H39.413zM39.413 49.015H55.02v1.213H39.413zM39.413 51.869H55.02v1.213H39.413z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#64C0C3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.413 7.97h4.89v1.213h-4.89zM50.016 7.97h5.004v1.213h-5.004zM39.413 10.825h4.89v1.213h-4.89zM50.016 10.825h5.004v1.213h-5.004zM39.413 13.669h4.89v1.213h-4.89zM50.016 13.669h5.004v1.213h-5.004zM39.413 16.523h4.89v1.213h-4.89zM50.016 16.523h5.004v1.213h-5.004z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#64C0C3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.413 19.34h4.89v1.212h-4.89zM50.016 19.34h5.004v1.212h-5.004zM39.413 22.194h4.89v1.213h-4.89zM50.016 22.194h5.004v1.213h-5.004zM39.413 25.038h4.89v1.213h-4.89zM50.016 25.038h5.004v1.213h-5.004zM39.413 27.892h4.89v1.213h-4.89zM50.016 27.892h5.004v1.213h-5.004z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#AFD7C7",
    d: "M53.216 36.298H72V60H53.216z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#F6C760"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.555 39.435h1.931v3.08h-1.93zM67.555 46.113h1.931v3.152h-1.93zM61.984 39.435h1.931v3.08h-1.93zM61.984 46.113h1.931v3.152h-1.93zM56.393 39.435h1.931v3.08h-1.93zM56.393 46.113h1.931v3.152h-1.93z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M67.555 53.064h1.931v3.08h-1.93zM56.393 53.064h1.931v3.08h-1.93z"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "#1B7690"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.816 4.703h2.55v3.08h-2.55zM18.816 11.383h2.55v3.152h-2.55zM11.456 4.703h2.55v3.08h-2.55zM11.456 11.383h2.55v3.152h-2.55zM4.07 4.703h2.55v3.08H4.07zM4.07 11.383h2.55v3.152H4.07z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M18.816 18.331h2.55v3.08h-2.55zM11.456 18.331h2.55v3.08h-2.55zM4.07 18.331h2.55v3.08H4.07z"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArtBusiness);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/art-business.acdb5bb82ac3eb30032c036176503ed1.svg";